module.exports = __webpack_public_path__ + "static/media/icon-attacking-shot.0eb31baa.svg";